export const PROJECT_STATUSES = ["ACTIVE", "IN_PROGRESS", "NEW"] as const;

export type ProjectStatus = (typeof PROJECT_STATUSES)[number];

export interface Project {
  uuid: string;
  name: string;
  description: string;
  status: ProjectStatus;
  organization: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}